import { createAsyncThunk, createSlice, isAsyncThunkAction,PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import fetchAPI from '../../../common/fetchAPI'
import { TaskTypeStateClass } from "./interfaces/TaskTypeStateClass";
import { sortData } from "../../../common/timeLiveFunction";

const initialState: TaskTypeStateClass = {
    isLoading: false,
    TaskTypeList: [],
    status: "idle",
    selectedRecord: {},
    isReload: false,
    sortOrder: 'asc',
    sortColumn: 'TaskType',
    search: '',
    pageNo: 1,
    pageSize: 10
};

interface IThunkApi {
    state: {
        taskType: TaskTypeStateClass
    }
};

export const getAccountTaskTypesAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        "TaskType/v2/getTaskType",
        async (arg, thunkApi) => {
            //const response = await fetchAPI("api/TaskTypes", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const response = await fetchAPI("api/v2/TaskTypes", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = await response.json();
            return json;
        }

    )
export const getAccountTaskTypesByAccountTaskTypeIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "TaskType/v2/getAccountTaskTypesByAccountTaskTypeId",
        async (arg, thunkApi) => {
            //const response = await fetchAPI('api/TaskTypes/' + arg, 'GET', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const response = await fetchAPI('api/v2/TaskTypes/' + arg, 'GET', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )
export const addAccountTaskTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'TaskType/v2/addAccountTaskType',
        async (arg, thunkApi) => {
            //const response = await fetchAPI('api/TaskTypes/', 'POST', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const response = await fetchAPI('api/v2/TaskTypes/', 'POST', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )

export const updateAccountTaskTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'TaskType/v2/updateAccountTaskType',
        async (arg, thunkApi) => {
            //const {AccountLocationId} = arg;
            const { AccountTaskTypeId, ...argWithoutId } = arg;
            //const response = await fetchAPI('api/TaskTypes/' + AccountTaskTypeId, 'POST', argWithoutId, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const response = await fetchAPI('api/v2/TaskTypes/' + AccountTaskTypeId, 'PUT', argWithoutId, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )
export const deleteAccountTaskTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "TaskType/v2/deleteAccountTaskType",
        async (arg, thunkApi) => {
            //const response = await fetchAPI('api/TaskTypes/' + arg, 'Delete', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const response = await fetchAPI('api/v2/TaskTypes/' + arg, 'Delete', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;

        }
    )
export const DeleteSelectedAccountTaskTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "TaskTypes/v2/DeleteSelectedAccountTaskType",
        async (arg, thunkApi) => {
            //const response = await fetchAPI('api/TaskTypes/DeleteSelected/', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const response = await fetchAPI('api/v2/TaskTypes/DeleteSelected/', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;

        }
    )

export const taskTypeSlice = createSlice({
    name: "taskType",
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {}
        },
        checkedState: (state, action) => {
            const currentindex = state.TaskTypeList.findIndex((item) => item.AccountTaskTypeId == action.payload);
            const newArray = [...state.TaskTypeList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.TaskTypeList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.TaskTypeList.findIndex((item) => item.AccountTaskTypeId == action.payload);
            const newArray = [...state.TaskTypeList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.TaskTypeList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.TaskTypeList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.TaskTypeList = newArray;
            //state.isAllUnChecked = false;
        },
        unCheckedAllState: (state) => {
            const newArray = state.TaskTypeList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.TaskTypeList = newArray;
            //state.isAllUnChecked = true;
        },
        checkAllCheckboxIsUncheckedState: (state) => {
            //state.isAllUnChecked = state.LocationList.every((item) => item.isSelected === 0);
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.TaskTypeList;
            state.TaskTypeList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountTaskTypesAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAccountTaskTypesAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (Object.keys(payload.Data).length === 0) {
                    // Handle the case where payload.Data is empty or an empty object
                    state.TaskTypeList = [];
                } else {
                    state.TaskTypeList = payload.Data;
                    state.TaskTypeList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                state.isReload = false;
                state.selectedRecord = {};
                state.isLoading = false;
            })
            .addCase(getAccountTaskTypesAsync.rejected, (state) => {
                state.status = 'failed';
            })



            .addCase(getAccountTaskTypesByAccountTaskTypeIdAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAccountTaskTypesByAccountTaskTypeIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (Object.keys(payload.Data).length === 0) {
                    // Handle the case where payload.Data is empty or an empty object
                    state.selectedRecord = {};
                } else {
                    state.selectedRecord = payload.Data[0];
                }
                
                state.isLoading = false;
            })
            .addCase(getAccountTaskTypesByAccountTaskTypeIdAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(addAccountTaskTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(addAccountTaskTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(addAccountTaskTypeAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(updateAccountTaskTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(updateAccountTaskTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(updateAccountTaskTypeAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(deleteAccountTaskTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(deleteAccountTaskTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(deleteAccountTaskTypeAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(DeleteSelectedAccountTaskTypeAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(DeleteSelectedAccountTaskTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(DeleteSelectedAccountTaskTypeAsync.rejected, (state) => {
                state.status = 'failed';
            })

    }
});

export const { resetSelectedRecordObjectInState, checkedState, unCheckedState, checkedAllState, unCheckedAllState, checkAllCheckboxIsUncheckedState,updatePagination,updateSorting } = taskTypeSlice.actions
export const taskTypeState = (state: RootState) => state.taskType
export default taskTypeSlice.reducer


